import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';
import RadioButton from 'shared/components/ui/radioButton';
import PaymentMethodForm from './form';
import PaymentLogo from './logo';
import { trackNow } from 'shared/models/analytic';

let PaymentMethods = class PaymentMethods extends React.Component {
  render() {
    if (this.props.loading || this.props.paymentRequestLoading)
      return (
        <div className="row center-xs">
          <div className="col-xs-12">
            <LoadingSpinner green inline />
          </div>
        </div>
      );

    return this.props.paymentMethods.length ||
      !!this.props.paymentRequestPayment ? (
      <PaymentMethodPicker {...this.props} />
    ) : (
      <PaymentMethodForm
        onSuccess={this.props.onNewPaymentSuccess}
        deliveryAddress={this.props.deliveryAddress}
      />
    );
  }
};

PaymentMethods = connect(
  state => ({
    selected: state.checkout.paymentMethod,
    paymentRequestPayment: state.checkout.paymentRequestPayment,
    paymentRequestLoading: state.checkout.paymentRequestLoading,
    paymentMethods: state.payment.cards || [],
    loading: state.payment.loading,
    user: state.login.user || {}
  }),
  {}
)(PaymentMethods);

class PaymentMethodPicker extends React.Component {
  constructor(props) {
    super(props);
    const preselected = this._preselected(props);
    this.state = {
      showNew: false,
      selected: preselected || {}
    };
  }

  _preselected(props) {
    if (!_.isEmpty(props.selected)) return props.selected;
    if (props.paymentRequestPayment) return props.paymentRequestPayment;
    if (props.paymentMethods.length) return props.paymentMethods[0];
  }

  openNewPaymentMethod() {
    this.setState({ showNew: true });
    trackNow('Add New Payment Clicked');
  }

  closeNewPaymentMethod() {
    this.setState({ showNew: false });
    trackNow('Add New Payment Canceled');
  }

  select(method) {
    this.setState({ selected: method });
  }

  confirmSelection() {
    this.props.onSelectionSubmit(this.state.selected);
  }

  render() {
    const paymentRequestPayment = this.props.paymentRequestPayment;
    const paymentMethods = (paymentRequestPayment
      ? [paymentRequestPayment]
      : []
    ).concat(this.props.paymentMethods || []);

    return (
      <div>
        <div className="radio-list vertical-rhythm">
          {paymentMethods.map(method => (
            <PaymentMethodItem
              key={method.id}
              id={method.id}
              brand={method.brand}
              last4={method.last4}
              expMonth={method.exp_month}
              expYear={method.exp_year}
              onChange={() => this.select(method)}
              checked={
                !this.state.showNew && method.id === this.state.selected.id
              }
            />
          ))}
        </div>

        {this.state.showNew ? (
          <PaymentMethodForm
            fieldsContainer={NewMethodFieldsContainer}
            onCancel={() => this.closeNewPaymentMethod()}
            onSuccess={this.props.onNewPaymentSuccess}
            deliveryAddress={this.props.deliveryAddress}
          />
        ) : (
          <div>
            <button
              type="button"
              className="btn--full-width btn--tertiary user-addresses__btn"
              onClick={() => this.openNewPaymentMethod()}
            >
              <span className="svg-icon svg-icon--plus" />
              Add New Payment Method
            </button>

            <div className="row">
              <div className="col-xs-12 col-md-5 col-md-offset-7 col-lg-4 col-lg-offset-8">
                <button
                  type="button"
                  className="btn-primary green btn--full-width"
                  onClick={() => this.confirmSelection()}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function PaymentMethodItem(props) {
  const checked = props.checked;
  const itemClassName =
    'radio-list__option' + (checked ? ' radio-list__option--checked' : '');
  const btnClassName =
    'radio-list__radio-btn' +
    (checked ? ' radio-list__radio-btn--checked' : '');
  const expDate =
    props.expMonth && props.expYear
      ? `${props.expMonth}/${Number(props.expYear) % 2000}`
      : '';

  return (
    <RadioButton
      name="payment-method"
      id={props.id}
      onChange={props.onChange}
      checked={checked}
      containerClass={itemClassName}
      btnClass={btnClassName}
    >
      <div className="radio-list__content">
        <div className="row middle-xs">
          <div className="col-xs">
            <span>
              {props.brand} {props.last4}
            </span>
            <PaymentLogo large className="right" brand={props.brand} />
            {expDate && (
              <span className="right payment-method__expiration">
                Expires {expDate}
              </span>
            )}
          </div>
        </div>
      </div>
    </RadioButton>
  );
}

function NewMethodFieldsContainer(props) {
  return (
    <div className="checkout-subsection">
      <h3 className="user-addresses__form-heading">New Payment Method</h3>
      {props.children}
    </div>
  );
}

export default PaymentMethods;



// WEBPACK FOOTER //
// ./shared/components/payment/index.js